import React from "react";

/**
 * Error Boundary component to catch and handle errors in child components
 * Prevents the entire app from crashing if a component fails
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log error details for debugging
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Silently fail for non-critical components
      // Return null to prevent rendering any error UI
      if (this.props.silent) {
        return null;
      }

      return (
        <div style={{ padding: "10px", color: "red", fontSize: "12px" }}>
          Something went wrong. Please refresh the page.
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
